"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StandardImage = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = require("react-helmet");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var StandardImage = function StandardImage(props) {
  var url = props.url,
      mobileUrl = props.mobileUrl,
      alt = props.alt,
      title = props.title,
      loadingMethod = props.loadingMethod,
      onClick = props.onClick,
      isFullWidth = props.isFullWidth;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, mobileUrl ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("picture", {
    style: {
      width: isFullWidth ? '100%' : 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement("source", {
    srcSet: url,
    media: "(min-width: 768px)"
  }), /*#__PURE__*/_react["default"].createElement("img", _extends({
    src: mobileUrl,
    alt: alt,
    title: title
  }, typeof onClick === 'function' && {
    onClick: onClick,
    style: {
      cursor: 'zoom-in'
    }
  }, loadingMethod === 'lazyload' && {
    loading: 'lazy'
  }))), loadingMethod === 'preload' && /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("link", {
    rel: "preload",
    href: mobileUrl,
    as: "image",
    media: "(max-width: 768px)"
  }), /*#__PURE__*/_react["default"].createElement("link", {
    rel: "preload",
    href: url,
    as: "image",
    media: "(min-width: 768.1px)"
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", _extends({
    src: url,
    alt: alt,
    title: title
  }, typeof onClick === 'function' && {
    onClick: onClick,
    style: {
      cursor: 'zoom-in'
    }
  }, loadingMethod === 'lazyload' && {
    loading: 'lazy'
  })), loadingMethod === 'preload' && /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("link", {
    rel: "preload",
    href: url,
    as: "image"
  }))));
};

exports.StandardImage = StandardImage;